module.exports = __webpack_public_path__ + "img/sprinkle-24.f23db9ab.jpg";